export default __webpack_public_path__ + "static/Cover-dd420472937a7bebb3a0011cbf5daa80.png";